var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "22",
        height: "22",
        viewBox: "0 0 58 58",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("rect", {
        attrs: {
          x: "1.5",
          y: "1.5",
          width: "55",
          height: "55",
          fill: "white",
          stroke: "currentColor",
          "stroke-width": "3"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M6.5 50C6.5 50.8284 7.17157 51.5 8 51.5H21.5C22.3284 51.5 23 50.8284 23 50C23 49.1716 22.3284 48.5 21.5 48.5H9.5V36.5C9.5 35.6716 8.82843 35 8 35C7.17157 35 6.5 35.6716 6.5 36.5V50ZM51.5 8C51.5 7.17157 50.8284 6.5 50 6.5H36.5C35.6716 6.5 35 7.17157 35 8C35 8.82843 35.6716 9.5 36.5 9.5H48.5V21.5C48.5 22.3284 49.1716 23 50 23C50.8284 23 51.5 22.3284 51.5 21.5V8ZM9.06066 51.0607L51.0607 9.06066L48.9393 6.93934L6.93934 48.9393L9.06066 51.0607Z",
          fill: "currentColor"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M50 51.5C50.8284 51.5 51.5 50.8284 51.5 50L51.5 36.5C51.5 35.6716 50.8284 35 50 35C49.1716 35 48.5 35.6716 48.5 36.5L48.5 48.5L36.5 48.5C35.6716 48.5 35 49.1716 35 50C35 50.8284 35.6716 51.5 36.5 51.5L50 51.5ZM8 6.5C7.17157 6.5 6.5 7.17157 6.5 8L6.5 21.5C6.5 22.3284 7.17157 23 8 23C8.82843 23 9.5 22.3284 9.5 21.5L9.5 9.5L21.5 9.5C22.3284 9.5 23 8.82843 23 8C23 7.17157 22.3284 6.5 21.5 6.5L8 6.5ZM51.0607 48.9393L9.06066 6.93934L6.93934 9.06066L48.9393 51.0607L51.0607 48.9393Z",
          fill: "currentColor"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "29",
          y: "17.6863",
          width: "16",
          height: "16",
          transform: "rotate(45 29 17.6863)",
          fill: "white"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }